import React from 'react';
import Navbar from './components/Navbar';
import AIChat from './components/AIChat';

function App() {
    return (
        <div className="min-h-screen bg-dark-bg text-dark-text">
            {/* Modern gradient background */}
            <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-dark-bg to-dark-bg pointer-events-none" />

            {/* Subtle noise texture */}
            <div className="fixed inset-0 opacity-[0.15] bg-[url('https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExazZtNGcwYnM3Y3AzMjdxeXVpam1vb28yM2x0bzJjeHNwa2Npd3I4ZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/wdfxqCQVGHDlC/giphy.gif')] pointer-events-none" />

            {/* Gradient orbs */}
            <div className="fixed top-20 -right-40 w-96 h-96 bg-primary/10 rounded-full blur-[128px] pointer-events-none" />
            <div className="fixed bottom-20 -left-40 w-96 h-96 bg-primary/5 rounded-full blur-[128px] pointer-events-none" />

            {/* Only show navbar on desktop */}
            <div className="hidden sm:block">
                <Navbar />
            </div>

            <main className="relative">
                <div className="h-screen sm:h-auto sm:min-h-[80vh] w-full mx-auto sm:px-6 lg:px-8">
                    <AIChat />
                </div>
            </main>
        </div>
    );
}

export default App; 